import React from 'react';
import { Pie } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { useSettingContextInComponent, useSettingsContext } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const PieSet = ({ dataProviderName, filters: defaultFilters }) => {
    const { t } = useTranslation();
    const { addFilter } = useSettingsContext(dataProviderName);
    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);

    const createSliceFilterHandler = (field, addFilter) => (params) => {
        addFilter(field, params);
    };

    return (drawable &&
        <Box className="report-itemgroup">
            <Box className="report-itemrow">
                <Box className="report-item">
                    <Pie
                        title={t("Lead by Area")}
                        dataProviderName={"statisticsviews/leadsperarea/aggregated/views_opportunities_lead/_related_area_name"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_area_name', addFilter)}
                    />
                </Box>
                <Box className="report-item">
                    <Pie
                        title={t("Lead by Shop")}
                        dataProviderName={"statisticsviews/leadspershop/aggregated/views_opportunities_lead/_related_shop_name"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_shop_name', addFilter)}
                    />
                </Box>
                <Box className="report-item">
                    <Pie
                        title={t("Lead by Agent")}
                        dataProviderName={"statisticsviews/leadsperagent/aggregated/views_opportunities_lead/_related_agent_fullname"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_agent_fullname', addFilter)}
                    />
                </Box>
            </Box>
            <Box className="report-itemrow">
                <Box className="report-item">
                    <Pie
                        title={t("Lead by Source")}
                        dataProviderName={"statisticsviews/leadspersource/aggregated/views_opportunities_lead/_related_source_name"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_source_name', addFilter)}
                    />
                </Box>
                <Box className="report-item">
                    <Pie
                        title={t("Lead by Status")}
                        dataProviderName={"statisticsviews/leadspersource/aggregated/views_opportunities_lead/status"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('status', addFilter)}
                    />
                </Box>
                <Box className="report-item">
                    <Pie
                        title={t("Lead by Product")}
                        dataProviderName={"statisticsviews/leadspersource/aggregated/views_opportunities_lead/product"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('product', addFilter)}
                    />
                </Box>
            </Box>
        </Box>
    )
}

export default PieSet;